import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import staticGameData from '../data/GameData';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class RoundIndicator extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.bg = null;
    this.roundNumDisplay = null;
    this.indicators = null;

    this.curIndicatorIndex = -1;

    this.bg = ABCyaPhaser.Images.addImage(0,-10, UIAssetKeys._mm_assets_QuestionIndicatorBg, this).setOrigin(0);

    // Make indictators
    this.indicators = [];
    const questionCount = 10; let i; let item;
    for (i = 0; i < questionCount; i++) {
      item = ABCyaPhaser.Images.addImage(20 * i + 50,25, UIAssetKeys._mm_assets_QuestionIndicatorFuture, this).setOrigin(0);
      this.indicators.push(item);
    }

    this.roundNumDisplay = ABCyaPhaser.Text.addText(150, 40, 22, 0xBC3F3F, FontKeys._BPreplay_Bold, `Round ${staticGameData.currentRound}`, this, true).setOrigin(0.5, 0);
  }

  nextQuestion (curQuestion) {
    if (this.curIndicatorIndex >= 0) {
      this.indicators[this.curIndicatorIndex].setFrame(UIAssetKeys._mm_assets_QuestionIndicatorPast).setOrigin(0);
    }
    this.curIndicatorIndex = curQuestion - 1;
    this.indicators[this.curIndicatorIndex].setFrame(UIAssetKeys._mm_assets_QuestionIndicatorPresent).setOrigin(0);
  }
}